export default __webpack_public_path__ + "static/media/driver.ac83e088.svg";